module.exports = __webpack_public_path__ + "static/img/ecode.fbee908c.png";